import { render, staticRenderFns } from "./legal-admin.vue?vue&type=template&id=6ef46f28"
import script from "./legal-admin.vue?vue&type=script&lang=ts"
export * from "./legal-admin.vue?vue&type=script&lang=ts"
import style0 from "./legal-admin.vue?vue&type=style&index=0&id=6ef46f28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports